import { render } from "./Certificados.vue?vue&type=template&id=3cf7a7b8&scoped=true"
import script from "./Certificados.vue?vue&type=script&lang=js"
export * from "./Certificados.vue?vue&type=script&lang=js"

import "./Certificados.vue?vue&type=style&index=0&id=3cf7a7b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cf7a7b8"]])

export default __exports__